import { TextBadge } from '#/components/Badge/TextBadge';
import { useI18n } from '#/i18n/hooks/useI18n';
import { SearchFacetAccordionItem } from '#/modules/search/components/Facet/AccordionItem/SearchFacetAccordionItem';
import { SearchFacetDropdown } from '#/modules/search/components/Facet/Dropdown/SearchFacetDropdown';
import { SearchFacetCheckboxOptions } from '#/modules/search/components/Facet/Options/SearchFacetCheckboxOptions';
import { SEARCH_VOLOP_REFINEMENT_LABELS } from '#/modules/search/constants/refinements/searchVolopRefinementTypes';
import { useSearchFacetSelectedValues } from '#/modules/search/hooks/facets/useSearchFacetSelectedValues';
import type { SearchRefinementVariant } from '#/modules/search/types/SearchRefinementVariant';
import { VOLOP_FUNCTION_CHECKBOX_OPTIONS } from '#/utils/constants/general/volopFunctions';

type Props = {
  variant: SearchRefinementVariant;
};

export function VolopKeywordsFacet({ variant }: Props) {
  const { i18n } = useI18n();
  const selectedFacetValues = useSearchFacetSelectedValues('functions');

  const FacetVariant =
    variant === 'accordion' ? SearchFacetAccordionItem : SearchFacetDropdown;

  return (
    <FacetVariant
      facetType="functions"
      icon="alternate-shapes"
      label={
        <>
          {SEARCH_VOLOP_REFINEMENT_LABELS(i18n).functions}{' '}
          <TextBadge content={selectedFacetValues.length} />
        </>
      }
    >
      <SearchFacetCheckboxOptions
        facetType="functions"
        initialValue={selectedFacetValues}
        options={VOLOP_FUNCTION_CHECKBOX_OPTIONS(i18n)}
        searchable
      />
    </FacetVariant>
  );
}
